import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Error } from "@progress/kendo-react-labels";
import { useEffect, useState } from "react";
import productsApi from "../../api/products";
import { useApi } from "../../hooks/useApi";
import { requiredValidator } from "../../validators";
import { ICompany } from "../admin/Company";
import { FormDropDownList } from "../form";
import { LoadingIndicator } from "../LoadingIndicator";

interface CopyPopupProps {
  data: any;
  onConfirm: (company: any | null) => void;
  handleClose: (event: any) => void;
}

export const CopyPopup = (props: CopyPopupProps) => {
  const {
    data: { instrumentId, commodityId, productType, companyId, quoteId },
    onConfirm,
    handleClose,
  } = props;
  const getCompaniesApi = useApi(productsApi.getCompanies);

  const [companies, setCompanies] = useState<ICompany[]>([]);

  useEffect(() => {
    getCompaniesApi.request(commodityId, instrumentId, productType);
  }, [commodityId, instrumentId, productType]);

  useEffect(() => {
    const list = getCompaniesApi.data?.companies || [];
    if (list.length === 0 && companyList.length === 0) return;

    setCompanies(list);
  }, [getCompaniesApi.data]);

  const companyList = companies.map((c: ICompany) => {
    return { value: c.id, label: c.name };
  });
  const [selected, setSelected] = useState<any>();

  useEffect(() => {
    if (companyList.length === 1) onConfirm(companies[0]);
    else if (companyList.length > 0 && !selected) {
      const initial = companyList?.find((c: any) => c.value === companyId);
      if (initial) setSelected({ company: initial });
    }
  }, [companies]);

  const onCompanyChange = (e: any) => {
    setSelected({ company: e.value });
  };

  const onCopy = () => {
    const company = companies.find((c) => c.id === selected.company.value);
    onConfirm(company);
  };

  return (
    <div>
      {companies.length > 1 && (
        <Dialog title={`Copy Quote ${quoteId}`} onClose={handleClose}>
          <LoadingIndicator loading={getCompaniesApi.loading} />
          {getCompaniesApi.error && <Error>{getCompaniesApi.error}</Error>}
          {!getCompaniesApi.loading && selected && (
            <Form
              initialValues={selected}
              render={() => (
                <FormElement>
                  {!getCompaniesApi.loading && companyList.length > 0 && (
                    <Field
                      key="company"
                      id="company"
                      name="company"
                      label={`Select Client Company:`}
                      textField="label"
                      dataItemKey="value"
                      onChange={onCompanyChange}
                      component={FormDropDownList}
                      validator={requiredValidator}
                      data={companyList}
                    />
                  )}
                </FormElement>
              )}
            />
          )}

          {getCompaniesApi.data && companyList.length === 0 && (
            <Error>This quote cannot be copied.</Error>
          )}

          <DialogActionsBar>
            {companyList.length > 0 && (
              <Button themeColor={"primary"} size={"small"} onClick={onCopy}>
                Copy
              </Button>
            )}
            <Button size={"small"} onClick={handleClose}>
              Cancel
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};
